export const getters = {
    getPedidoCompra: state => state.pedidoCompra,
    getPedidosCompras: state => state.pedidosCompras,
    getModalCadastroPedidoCompra: state => state.modalCadastrarPedidoCompra,
    getModalExcluirPedidoCompra: state => state.modalExcluirPedidoCompra,
    getModalPesquisarPedidoCompra: state => state.modalPesquisarPedidoCompra,
    getItensPedidoCompra: state => state.itensPedidoCompra,
    getModalEnviarEmailPedidoCompra: state => state.modalEnviarEmailPedidoCompra,
}

export default {}